import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_KEY, getCookie } from '../../constants/utilis';
import {
  Typography,
  Button,
  Grid,
  Paper,
  TextField,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  List,
  ListItem,
  makeStyles,
  Container,
  CircularProgress
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(4),
    margin: 'auto',
    backgroundColor: '#fafafa',
    boxShadow: theme.shadows[4],
    borderRadius: theme.shape.borderRadius,
  },
  uploadSection: {
    marginBottom: theme.spacing(4),
  },
  section: {
    marginTop: theme.spacing(4),
  },
  list: {
    marginTop: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    // backgroundColor: '#fff',
    borderRadius: theme.shape.borderRadius,
    // boxShadow: theme.shadows[1],
  },
  listItem: {
    padding: theme.spacing(1),
    borderBottom: '1px solid #eee',
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  caseIdField: {
    marginBottom: theme.spacing(2),
    width: '100%',
  },
  heading: {
    color: theme.palette.primary.dark,
    fontWeight: 600,
  },
  subHeading: {
    marginBottom: theme.spacing(1),
    // color: theme.palette.text.secondary,
  },
  loadingContainer: {
    marginTop: theme.spacing(10),
    textAlign: 'center',
  },
  ratingRed: {
    color: theme.palette.error.main, // red
    fontWeight: 700,
  },
  ratingOrange: {
    color: '#FF9800', // orange
    fontWeight: 700,
  },
  ratingGreen: {
    color: theme.palette.success.main, // green
    fontWeight: 700,
  },
}));

function PdfEvaluator() {
  const classes = useStyles();
  const [feedback, setFeedback] = useState(null);
  const [loading, setLoading] = useState(false);

  const id = sessionStorage.getItem("caseId");
  // console.log("IDDDD", id);

  useEffect(() => {
    if (id) {
      const url = `https://locationtec-api-cmhebpgsfndygrak.centralindia-01.azurewebsites.net/locationtec/v1/downloadPdf/${id}`
      handleUpload(url);
    }
  }, [id]);

  const handleUpload = async (url) => {
    setLoading(true);
    try {
      const response = await axios.post(
        'https://damage-api-heeygcgvfbfvhuff.centralindia-01.azurewebsites.net/locationtec/v1/auth/pdfReport',
        { pdfUrl: url },
        {
          headers: {
            'Content-Type': 'application/json',
            apikey: API_KEY,
            Authorization: 'Bearer ' + getCookie('at'),
          },
        }
      );
      setFeedback(response.data.feedback);
    } catch (err) {
      console.error('Upload error:', err);
      setFeedback(null);
    } finally {
      setLoading(false);
    }
  };

  const rating = feedback?.rating || 0;

  let ratingClass;
  if (rating >= 0 && rating <= 4) ratingClass = classes.ratingRed;
  else if (rating >= 5 && rating <= 6) ratingClass = classes.ratingOrange;
  else if (rating >= 7 && rating <= 10) ratingClass = classes.ratingGreen;

  return (
    <Container className="page-content" maxWidth="xl">
      <Paper className={classes.container} elevation={3}>
        <Typography variant="h4" gutterBottom className={classes.heading}>
          PDF Analyse Report
        </Typography>

        {loading ? (
          <div className={classes.loadingContainer}>
            <CircularProgress color="secondary" />
            <Typography variant="body1" style={{ marginTop: 16 }}>
              Processing PDF... Please wait
            </Typography>
          </div>
        ) : (
          <Typography variant="h5" className={`${classes.section} ${classes.heading}`}>
            Feedback
          </Typography>
        )}

        {feedback ? (
          <div>
            <div className={classes.section}>
              <Typography variant="subtitle1" className={classes.subHeading}>
                <strong>Case ID:</strong> {feedback.caseID || 'NA'}
              </Typography>
              <Typography variant="subtitle1" className={classes.subHeading}>
                <strong>Verification Type:</strong> {feedback.verificationType || 'NA'}
              </Typography>
              <Typography variant="subtitle1" className={ratingClass}>
                <strong>Rating:</strong> {rating}/10
              </Typography>
            </div>

            {feedback.incompleteFields?.length > 0 ? (
              <div className={classes.section}>
                <Typography variant="h6" className={classes.heading}>Incomplete Fields</Typography>
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ fontWeight: 'bold' }}>Field</TableCell>
                      <TableCell style={{ fontWeight: 'bold' }}>Value</TableCell>
                      <TableCell style={{ fontWeight: 'bold' }}>Note</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {feedback.incompleteFields.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell>{item.field}</TableCell>
                        <TableCell>{item.value || 'EMPTY FIELD'}</TableCell>
                        <TableCell>{item.note}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            ) : (
              <Typography>No incomplete fields found.</Typography>
            )}

            {feedback.missingFields?.length > 0 && (
              <div className={classes.section}>
                <Typography variant="h6" className={classes.heading}>Missing Fields</Typography>
                <List className={classes.list}>
                  {feedback.missingFields.map((field, index) => (
                    <ListItem key={index} className={classes.listItem}>
                      • {field}
                    </ListItem>
                  ))}
                </List>
              </div>
            )}

            {feedback.incorrectData?.length > 0 && (
              <div className={classes.section}>
                <Typography variant="h6" className={classes.heading}>Incorrect Data</Typography>
                <List className={classes.list}>
                  {feedback.incorrectData.map((item, index) => (
                    <ListItem key={index} className={classes.listItem}>
                      • {item.field}: {item.issue}
                    </ListItem>
                  ))}
                </List>
              </div>
            )}

            {feedback.otherObservations?.length > 0 && (
              <div className={classes.section}>
                <Typography variant="h6" className={classes.heading}>Other Observations</Typography>
                <List className={classes.list}>
                  {feedback.otherObservations.map((observation, index) => (
                    <ListItem key={index} className={classes.listItem}>
                      • {observation}
                    </ListItem>
                  ))}
                </List>
              </div>
            )}
          </div>
        ) : (
          <Typography>No feedback yet. Please wait for the report.</Typography>
        )}
      </Paper>
    </Container>
  );
}

export default PdfEvaluator;
